import { render, staticRenderFns } from "./OrderStateRestrictionUpdate.vue?vue&type=template&id=250a9728&"
import script from "./OrderStateRestrictionUpdate.vue?vue&type=script&lang=js&"
export * from "./OrderStateRestrictionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports